import {
  Box,
  Button,
  FormControl,
  Menu,
  Slider,
  Typography,
} from '@mui/material';
import { useMemo } from 'react';

const menuStyles = {
  '& .MuiPaper-root': {
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
    padding: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    ul: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

interface HomeModelsGenericSliderProps {
  title: string;
  open: boolean;
  disabled?: boolean;
  anchorEl: null | HTMLElement;
  handleChange: (newValue: number[], keyToUpdate: string) => void;
  handleClose: () => void;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  value: number[];
  minValue: number;
  maxValue: number;
  valueKey: string;
  money?: boolean;
}

export const HomeModelsGenericSlider = ({
  title,
  open,
  disabled,
  anchorEl,
  handleChange,
  handleClick,
  handleClose,
  value,
  minValue,
  maxValue,
  valueKey,
  money = false,
}: HomeModelsGenericSliderProps) => {
  const dropdownText = useMemo(() => {
    if (!value || (minValue == value[0] && maxValue == value[1])) {
      return title;
    } else if (value[0] && maxValue == value[1]) {
      return `More than ${money ? '$' : ''}${value[0].toLocaleString()}`;
    } else if (value[1] && minValue == value[0]) {
      return `Less than ${money ? '$' : ''}${value[1].toLocaleString()}`;
    } else if (value[1] && value[0]) {
      return `${money ? '$' : ''}${value[0].toLocaleString()} - ${money ? '$' : ''}${value[1].toLocaleString()}`;
    }
  }, [maxValue, minValue, money, title, value]);

  const valueLabelFormat = (value: number) => {
    return money ? `$${value}` : `${value}`;
  };

  return (
    <div>
      <Button
        disabled={disabled}
        data-open-price-dropdown
        id="open-price-dropdown-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="filled"
      >
        {dropdownText}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={menuStyles}
        slotProps={{
          list: {
            'aria-labelledby': 'open-price-dropdown-button',
          },
        }}
      >
        <div
          style={{
            paddingTop: '30px',
            paddingLeft: '15px',
            paddingRight: '15px',
          }}
        >
          <Slider
            min={minValue}
            max={maxValue}
            onChange={(_event, value) => {
              handleChange(value || [], valueKey);
            }}
            valueLabelDisplay="auto"
            getAriaValueText={valueLabelFormat}
            valueLabelFormat={valueLabelFormat}
            value={value}
          ></Slider>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" sx={{ cursor: 'pointer' }}>
              {money ? `$${minValue}` : minValue}
            </Typography>
            <Typography variant="body2" sx={{ cursor: 'pointer' }}>
              {money ? `$${maxValue}` : maxValue}
            </Typography>
          </Box>
        </div>

        <FormControl
          className="mobile-search-apply-buttons"
          sx={{ m: 1, width: '100%' }}
          size="small"
        ></FormControl>
      </Menu>
    </div>
  );
};
